//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultTgb from "@/components/objects/public/shared-blocks/tgbs/design-variant/Default.vue";
import WithBgTgb from "@/components/objects/public/shared-blocks/tgbs/design-variant/WithBg.vue";
import AccentTgb from "@/components/objects/public/shared-blocks/tgbs/design-variant/Accent.vue";
import TheEcharts from "@/components/TheEcharts.vue";
import { v4 as uuidv4 } from 'uuid';
import { DesignExtra } from "@/utils/dto/objects.js";
import isEmpty from "lodash/isEmpty.js";
import { getDefaultThemeSettings } from "@/constants/ui.js"

export default {
  name: "Tgbs",
  components: { TheEcharts },
  provide: {
    source: 'objTgbs',
    module: 'tgbs'
  },
  props: {
    tgb: {
      type: Object,
      default: () => null
    },
    objectLabel: {
      type: String,
      default: ''
    },
    objectId: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/prop-name-casing
    vistat_object: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {}
    },
    isArt: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const safeTgb = this.tgb || {};
    const design = safeTgb.design || 'tgbs_default';
    const ui = safeTgb.ui_data || {};
    const defaultTheme = getDefaultThemeSettings(design, 'tgbs', this.$store)?.themes?.[0];
    return {
      currentDesign: design,
      currentTheme: ui.design_theme || defaultTheme?.theme,
      designExtra: isEmpty(safeTgb.design_extra) ? new DesignExtra(defaultTheme) : safeTgb.design_extra,
      currentTemplate: null,
    }
  },
  computed: {
    renderComponent() {
      switch (this.currentDesign) {
      case "with-bg":
        return WithBgTgb
      case "accent":
        return AccentTgb
      default:
        return DefaultTgb
      }
    },
    listInfo() {
      return {
        vistat_object: this.vistat_object,
        object_label: this.objectLabel,
        id: uuidv4(),
      }
    },
  },
  methods: {
    onDesignChange(evt) {
      this.currentDesign = evt;
      this.designExtra = new DesignExtra(getDefaultThemeSettings(evt, 'tgbs', this.$store).themes[0]);
      this.currentTheme = getDefaultThemeSettings(evt, 'tgbs', this.$store).themes[0].theme;
    },
    onThemeChange(evt) {
      this.currentTheme = evt;
      this.designExtra = new DesignExtra(getDefaultThemeSettings(this.currentDesign, 'tgbs', this.$store).themes.find(el => el.theme === evt));
    },
  }
}
